export const ArrowNavigationAction = {
    Ready: "mini.doc.ready",
    Load: "mini.doc.load",
    Reload: "mini.doc.reload",
    Paginate: "mini.doc.paginate",
    SetIndex: "mini.doc.setIndex",
};
